import React, { useRef } from 'react';

function IVA() {
  const videoRef = useRef(null);

  const playIvaVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };
  return (
    <section className="section iva-section py-20">
      <div className="container">
        <div className="iva-content-wrapper flex flex-col md:flex-row justify-center">
          <div
            className="iva-intro aos-init aos-animate relative w-full md:w-1/3"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <picture>
              <source
                type="image/webp"
                srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/iva-announcement.webp"
              />
              <source
                type="image/jpg"
                srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/iva-announcement.jpg"
              />
              <img
                loading="lazy"
                src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/iva-announcement.jpg"
                alt="InVideo IVA Announcement"
              />
            </picture>
            <div className="iva-announcement-text absolute top-0 p-8">
              <h3
                style={{
                  color: '#7a7cbb',
                }}
                className="head1 text-3xl font-semibold mb-2"
              >
                Announcing our new
              </h3>
              <div className="combined-text ">
                <p className="head2 text-2xl font-semibold text-brandPrimary">
                  Intelligent Video Assistant - IVA
                  <span
                    className="mx-2 -top-1 relative p-1 beta-label uppercase text-white"
                    style={{
                      backgroundColor: '#8cba2f',
                      fontSize: '10px',
                    }}
                  >
                    Beta
                  </span>
                </p>
              </div>
            </div>
            <a
              aria-label="Intelligent Video Assistant"
              className="absolute bottom-0 px-8 py-4"
              href="/intelligent-video-assistant"
            >
              <div className="read-more flex items-center">
                <span className="text text-lg text-white">Read more</span>
                <span className="icon mx-2">
                  <img
                    alt="Read More IVA Icon"
                    loading="lazy"
                    src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/read-more-icon.svg"
                  />
                </span>
              </div>
            </a>
          </div>
          <div
            className="iva-demo aos-init my-4 md:m-8 aos-animate flex items-center flex-col relative w-full md:w-2/3"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div className="iva-video-wrapper p-4 border rounded-xl">
              <video
                poster="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/iva-video-thumb-small.jpg"
                playsInline
                ref={videoRef}
                preload="auto"
                className="iva-video"
                id="iva-video"
                muted
              >
                <source
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/iva-video.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
            <div className="iva-play-section absolute -bottom-20 md:-bottom-10 right-0 flex items-center">
              <div className="play-text mr-16 text-lg">
                <p>Click here to see</p>
                <p>
                  IVA
                  <span
                    className="mx-2 -top-1 relative p-1 beta-label uppercase text-white"
                    style={{
                      backgroundColor: '#8cba2f',
                      fontSize: '10px',
                    }}
                  >
                    Beta
                  </span>
                  in action.
                </p>
                <img
                  alt="IVA Play"
                  loading="lazy"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/iva-play-arrow.svg"
                  className="iva-play-arrow absolute left-1/2"
                />
              </div>
              <button
                type="button"
                onClick={playIvaVideo}
                className="play-action"
              >
                <img
                  alt="IVA View Demo"
                  loading="lazy"
                  src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/iva-view-demo-btn.svg"
                  className="iva-play-action animate-scale"
                  style={{
                    transform: 'scale(1.1)',
                  }}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default IVA;
